module.exports = __webpack_public_path__ + "static/media/avatar_3.6d68e718.png";